import {BulkDeleteClientError, BulkDeleteClientErrorReason} from "./BulkDeleteUrlsState";
import {MAX_UPLOAD_BYTES, formatUploadLimit} from "./bulkDeleteLimits";

const isCsv = (file: File): boolean => file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv");

export const validateCsvFile = (file: File): BulkDeleteClientError | null => {
  if (!isCsv(file)) {
    return {
      reason: BulkDeleteClientErrorReason.notCsv,
      message: "Please choose a .csv file exported from cached_urls."
    };
  }

  if (file.size > MAX_UPLOAD_BYTES) {
    return {
      reason: BulkDeleteClientErrorReason.tooLarge,
      message: `That file is larger than the ${formatUploadLimit()} limit. Trim the export or split it into smaller batches.`
    };
  }

  return null;
};
